import { Box, Container, Grid, Typography } from '@mui/material'
import type { ComponentType } from 'react'
import type { SvgIconProps } from '@mui/material'
import { COLOR_PRIMARY, BG_LIGHT, DARK_800 } from '../theme'

export interface HowItWorksStep {
    num: string
    Icon: ComponentType<SvgIconProps>
    title: string
    body: string
}

interface HowItWorksSectionProps {
    title?: string
    subtitle?: string
    steps: HowItWorksStep[]
    dark?: boolean
}

export function HowItWorksSection({
    title,
    subtitle,
    steps,
    dark = false,
}: HowItWorksSectionProps) {
    const colOffset = `${100 / (steps.length * 2)}%`
    const bg = dark ? DARK_800 : BG_LIGHT
    const titleColor = dark ? 'white' : undefined
    const subtitleColor = dark ? 'rgba(255,255,255,0.55)' : undefined
    const stepTitleColor = dark ? 'white' : undefined
    const stepBodyColor = dark ? 'rgba(255,255,255,0.55)' : undefined
    const stepLabelColor = dark ? COLOR_PRIMARY : COLOR_PRIMARY
    //const iconBg = dark ? 'rgba(255,255,255,0.06)' : 'white'
    const iconBg = dark ? DARK_800 : 'white'

    return (
        <Box sx={{ backgroundColor: bg, py: { xs: 6, md: 10 } }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography variant="h2" sx={{ mb: 2, color: titleColor }}>{title}</Typography>
                    <Typography variant="body1" sx={{ color: subtitleColor ?? 'text.secondary' }}>{subtitle}</Typography>
                </Box>
                <Box sx={{ position: 'relative' }}>
                    {/* Connecting line desktop only */}
                    <Box sx={{
                        display: { xs: 'none', md: 'block' },
                        position: 'absolute',
                        top: 47,
                        left: `calc(${colOffset})`,
                        right: `calc(${colOffset})`,
                        height: 0,
                        borderTop: `2px solid ${COLOR_PRIMARY}90`,
                        zIndex: 0,
                    }} />
                    <Grid container spacing={2}>
                        {steps.map((step, i) => (
                            <Grid item xs={12} sm={6} md={Math.floor(12 / steps.length) as any} key={i}>
                                <Box sx={{ position: 'relative', textAlign: 'center', px: 2 }}>
                                    <Box sx={{
                                        width: 64, height: 64, borderRadius: '50%',
                                        background: iconBg,
                                        border: `2px solid ${COLOR_PRIMARY}`,
                                        boxShadow: `0 0 0 5px rgba(244,182,50,0.1)`,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        mx: 'auto', mb: 3,
                                        position: 'relative', zIndex: 1,
                                    }}>
                                        <step.Icon sx={{ color: stepLabelColor, fontSize: 28 }} />
                                    </Box>
                                    <Typography variant="caption" sx={{ color: stepLabelColor, fontWeight: 700, letterSpacing: '1px' }}>
                                        STEP {step.num}
                                    </Typography>
                                    <Typography variant="h5" sx={{ mt: 0.5, mb: 1.5, color: stepTitleColor }}>{step.title}</Typography>
                                    <Typography variant="body2" sx={{ lineHeight: 1.7, color: stepBodyColor ?? 'text.secondary' }}>
                                        {step.body}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    )
}
